import React, { useState } from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Link } from "react-router-dom";
import faqBanner from "../../Images/student-services/ragging.webp";
import classroomImage from "../../Images/gov-body/rules.webp";
import { Row } from "react-bootstrap";

const body = [
    { name: "Prof. (Dr) Anand Mahalwar", remarks: "Chairman" },
    { name: "Dr. B. P. Bhol", remarks: "Registrar" },
    { name: "Dr. Sandeep Kumar", remarks: "DSW, Member" },
    { name: "Dr. Shameen Ahmad Khan", remarks: "ARC, Member" },
    { name: "Dr. Arun Kumar Singh", remarks: "ARC, Member" },
    { name: "Dr. N. Kumar Swamy", remarks: "ARC, Member" },
    { name: "Mr. R.K Deshmukh", remarks: "Hostel Warden (Boys)" },
    { name: "Dr. Tripti Shastri", remarks: "Hostel Warden (Girls)" },
    { name: "TI, Chhura", remarks: "Member representative of Police Admin" },
    { name: "Mr. Yashwant Yadaw", remarks: "Member Local Media" },
    { name: "Mr. Sheetal Dhruw", remarks: "Member NGO" },
    { name: "Mr. Pukhraj Yadaw", remarks: "Member Non teaching" },
    { name: "Mr. Arjun Singh", remarks: "Member (Administration)" },
    { name: "Mr. Chamru Ram", remarks: "Member Parents" },
    { name: "Mr. Dharmendra Chandrakar", remarks: "Member Parents" },
    { name: "Ms. Rukhmani (BA)", remarks: "Member Student – Fresher’s" },
    { name: "Shishir Chandrakar (B.Com)", remarks: "Member Student – Fresher’s" },
    { name: "Ms. Manisha Dhruw (BA)", remarks: "Member Senior Student" },
    { name: "Mr. Cheman Lal (B.Com)", remarks: "Member Senior Student" }
];

const RaggingCommittees = () => {
    return (
        <>
            <title>ISBM University Anti-Ragging Committee | Ensuring a Safe Campus Environment</title>
            <meta
                name="description"
                content="Ensure your safety at ISBM University. Our Anti-Ragging Committee prevents harassment and maintains a secure campus environment. Learn more now."
            />
            <Topnav />
            <section
                className="section-hero-banner ptb-50"
                style={{
                    backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${faqBanner})`,
                }}
            >
                <div className="banner-hero-overlay">
                    <div className="container-xxl">
                        <div className="section-hero-content">
                            <h1>Anti-Ragging Committees</h1>
                            <ol className="breadcrumb mt-3 text-center mb-0">
                                <li className="breadcrumb-item">
                                    <Link to="/" style={{ color: "#fff", textDecoration: "none" }}>
                                        Home
                                    </Link>
                                </li>
                                <li className="breadcrumb-item active text-white" aria-current="page">
                                    Anti-Ragging Committees
                                </li>
                                <hr className="section-divider" />
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            <section className="bg-light">
                <div className="container-xxl ptb-50">
                    <Row className="m-0">
                        <div className="col-md-6">
                            <h2 className="modern-title text-blue">Anti-Ragging Committees</h2>
                            <div className="underline-divider mb-3"></div>
                            <p className="text-muted">
                                ISBM University maintains a zero-tolerance policy towards ragging and
                                is fully committed to creating a safe, respectful, and inclusive environment
                                for all students. To uphold this commitment, the university has established
                                dedicated Anti-Ragging Committees and Squads in accordance with UGC guidelines.
                                These bodies actively monitor student interactions and ensure strict
                                compliance with anti-ragging regulations on and off campus.
                            </p>
                            <p className="text-muted">
                                The committees consist of senior faculty members, administrative staff,
                                and student representatives who work together to prevent, detect, and respond
                                promptly to any reported incidents. Awareness programs, orientation sessions,
                                and regular inspections are conducted to educate students about the consequences
                                of ragging and promote a culture of mutual respect. ISBM University encourages
                                students to report any grievances confidently, ensuring their privacy and safety
                                at all times.
                            </p>
                        </div>
                        <div className="col-md-6">
                            <div className="governing-image-wrapper shadow">
                                <img src={classroomImage} alt="Governing Body" />
                            </div>
                        </div>
                    </Row>
                </div>
            </section>

            <section className="visa-section py-5 bg-light">
                <div className="container-xxl">
                    <h2 className="text-center modern-title text-blue">Anti-Ragging Committees</h2>
                    <div className="underline-center mb-5 mx-auto"></div>
                    <div className="row m-0">
                        {body.map((member, index) => (
                            <div className="col-lg-4 col-md-6 d-flex mb-3" key={index}>
                                <div className="visa-box p-4 shadow w-100 h-100 d-flex flex-column">
                                    <div className="visahead">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <h5 className="text-dark mb-0">{member.name}</h5>
                                            <span className="badge designation ms-2 ">
                                                {member.designation}
                                            </span>
                                        </div>
                                        <div className="underlinetwo"></div>
                                    </div>
                                    <ul className="mb-0 list-unstyled">
                                        <li>{member.remarks}</li>
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default RaggingCommittees;
